/* Diwali registration page (sections/diwali-registration.liquid, 19 Oct 2026).

   Built from the team's Claude Design file "Diwali Sale Landing v2":
   - desktop, option 2a: the cursor becomes a sparkler; registering sets off a burst;
   - phone, option 3a: a sparkler traces a long-exposure ring around the watch dial
     (once, then stops: Punit, 20 Oct); a finger drags it; registering sets off a burst.
   The spark engine is the design's own, ported to a canvas measured in CSS pixels.
   The sparkler works anywhere on the page, not just over this section (Punit,
   19 Oct): its canvas is fixed over the whole window.

   Registrations post into a hidden iframe. An Apps Script web app can't answer a
   cross-origin fetch, so the iframe's load event is the success signal, the same
   pattern as AC's cosmic-prebuzz form. The script itself is in
   diwali-2026/registrations-apps-script.gs. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };

  /* ----- Meta: CompleteRegistration from this page (20 Oct 2026) -----
     The user: "add the custom pixel code directly to the website code files" (no
     Customer events access for a custom pixel). After a registration goes through,
     this page sends ONE event to Verte's dataset, CompleteRegistration, with the
     visitor's phone, name and city as advanced matching, hashed here with SHA-256.
     Never PageView: the Facebook & Instagram app sends those.

     It does NOT go through window.fbq. On the live store fbq belongs to that app,
     which runs Meta's pixel in a Shopify sandbox mode (set shopifySandboxContext,
     init with agent shopify_web_pixel, its own events via trackShopify) and swallows
     any plain fbq('track'): checked 20 Oct with Meta's own library in a normal-looking
     browser, a CompleteRegistration on a plain page went out as one request, the same
     calls on the live Diwali page sent nothing, and the two real registrations that
     evening never reached the dataset. So the event goes out as the request Meta's
     library itself builds, an image GET to facebook.com/tr with the same parameters
     (id, ev, dl, rl, ts, eid, cd[], ud[] hashed, fbp, fbc). The app stays: it carries
     the shop events, checkout, server events and catalog. eid is the event_id the
     Apps Script's Conversions API call would use, so Meta counts the pair once. */
  var META_PIXEL_ID = '878409133832075'; // "Verte's Dataset"

  // If the store ever shows a consent banner (Shopify's Customer Privacy API), respect a
  // "no" to marketing; with none, as on verte.co.in today, it is allowed.
  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false;
    } catch (_) { /* no API: allowed */ }
    return true;
  }

  // Meta's advanced matching formats: lowercase, no punctuation or spaces. Built with
  // new RegExp so a browser without Unicode property escapes falls back instead of
  // failing to parse this whole file.
  var notLetter;
  try { notLetter = new RegExp('[^\\p{L}\\p{M}\\p{N}]', 'gu'); } catch (_) { notLetter = /[^a-z0-9]/g; }
  function metaNorm(v) { return String(v || '').toLowerCase().replace(notLetter, ''); }

  // The phone as digits with the country code, the same rules as the Apps Script.
  function metaPhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    else if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    if (d.length === 10) return '91' + d;
    return d.length >= 11 && d.length <= 15 ? d : '';
  }

  function sha256Hex(text) {
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      var bytes = new Uint8Array(buf), out = '';
      for (var i = 0; i < bytes.length; i++) out += ('0' + bytes[i].toString(16)).slice(-2);
      return out;
    });
  }

  // r: { eventId, name, phone, city, fbp, fbc }
  function sendMetaRegistration(r) {
    try {
      if (!marketingAllowed()) return;
      var parts = r.name.split(/\s+/);
      var first = parts.shift();
      var ud = {};
      var ph = metaPhone(r.phone), fn = metaNorm(first), ln = metaNorm(parts.join(' ')), ct = metaNorm(r.city);
      if (ph) ud.ph = ph;
      if (fn) ud.fn = fn;
      if (ln) ud.ln = ln;
      if (ct) ud.ct = ct;
      if (ph && ph.indexOf('91') === 0 && ph.length === 12) ud.country = 'in';
      var keys = Object.keys(ud);
      // crypto.subtle needs https (verte.co.in is); without it the event goes without them.
      var canHash = window.crypto && window.crypto.subtle && window.TextEncoder;
      (canHash ? Promise.all(keys.map(function (k) { return sha256Hex(ud[k]); })) : Promise.resolve(null))
        .catch(function () { return null; })
        .then(function (hashes) {
          var q = [
            'id=' + META_PIXEL_ID,
            'ev=CompleteRegistration',
            'dl=' + encodeURIComponent(location.href),
            'rl=' + encodeURIComponent(document.referrer || ''),
            'ts=' + Date.now(),
            'eid=' + encodeURIComponent(r.eventId),
            'cd[content_name]=' + encodeURIComponent('Diwali 2026 registration'),
            'cd[content_category]=registration'
          ];
          if (hashes) keys.forEach(function (k, i) { q.push('ud[' + k + ']=' + hashes[i]); });
          if (r.fbp) q.push('fbp=' + encodeURIComponent(r.fbp));
          if (r.fbc) q.push('fbc=' + encodeURIComponent(r.fbc));
          var img = new Image(1, 1);
          window.__dwMetaPing = img; // keep a reference until it has gone out
          img.src = 'https://www.facebook.com/tr/?' + q.join('&');
        });
    } catch (_) { /* tracking must never break the thank-you state */ }
  }

  // The canvas is fixed over the window, so every position here is in viewport
  // (client) pixels. opts.boost() returns the phone factors ({ size, life }) on
  // the phone layout and null on desktop, where the design's numbers stand.
  function makeEngine(canvas, opts) {
    var ctx = canvas.getContext('2d');
    var W = 0, H = 0;
    // ringLeft: how much of the phone ring is still to be drawn, in radians. It goes
    // round opts.ringLoops times and then stops for good (Punit, 20 Oct: "Just
    // once. Not keep circling"); it used to circle whenever the phone was idle.
    // With opts.ringUntilTouch the visitor's first touch also ends it (ringOver), and
    // if it is circling right then, its sparkler flies to the finger (fly).
    var E = {
      sparks: [], tip: null, touch: false, newStroke: false, linger: null, lastTouch: 0, ang: -1.57, trail: [],
      ringLeft: opts.ringLoops * 6.2832, ringOver: false, ringOn: false, ringTip: null, fly: null, joinTrail: false
    };

    E.resize = function () {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      W = canvas.clientWidth; H = canvas.clientHeight;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    // w scales the spark's line width, l the life of the sparks it crackles into.
    E.emit = function (x, y, sp, life, w, l) {
      var a = Math.random() * 6.283;
      E.sparks.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 0.4, life: life, max: life, split: Math.random() < 0.18, w: w || 1, l: l || 1 });
    };
    // A finger lifted. On phones the sparkler burns on where it was for a moment,
    // dying down, instead of stopping dead (Punit, 20 Oct: "very small and for a
    // short time ... we need it a bit dragged").
    E.release = function () {
      var b = opts.boost && opts.boost();
      if (E.fly && E.tip) {
        // Still flying to the finger: it lands there, then burns down (see frame).
        E.fly.to = { x: E.tip.x, y: E.tip.y };
      } else if (E.tip && E.touch && b) {
        var span = 350 * b.life;
        E.linger = { x: E.tip.x, y: E.tip.y, until: Date.now() + span, span: span };
      }
      E.tip = null;
      E.touch = false;
    };
    // The first touch, in until-touch mode: the ring is over for good, and if it is
    // circling right now its sparkler is caught: it flies from the ring to the finger.
    E.catchRing = function (x, y) {
      if (!opts.ringUntilTouch || E.ringOver) return;
      E.ringOver = true;
      if (E.ringOn && E.ringTip) {
        E.fly = { x: E.ringTip.x, y: E.ringTip.y, to: { x: x, y: y }, t0: Date.now(), dur: 250 };
        E.joinTrail = true;
      }
    };
    E.burstAt = function (el, n) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      var x = r.left + r.width / 2, y = r.top + r.height / 2;
      for (var i = 0; i < n; i++) E.emit(x, y, 2 + Math.random() * 9, 40 + Math.random() * 50);
    };
    function glow(x, y, R, alpha) {
      var g = ctx.createRadialGradient(x, y, 0, x, y, R);
      g.addColorStop(0, 'rgba(255,250,230,1)');
      g.addColorStop(0.25, 'rgba(255,200,90,.85)');
      g.addColorStop(1, 'rgba(255,150,40,0)');
      ctx.globalAlpha = alpha;
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, R, 0, 6.29); ctx.fill();
      ctx.globalAlpha = 1;
    }
    // Draws one frame; returns true while there is anything left to animate.
    E.frame = function () {
      ctx.clearRect(0, 0, W, H);
      var now = Date.now();
      var boost = opts.boost ? opts.boost() : null;
      var size = boost ? boost.size : 1, longer = boost ? boost.life : 1;
      var tip = E.tip, scale = 1, power = 1;
      var source = tip ? (E.touch ? 'touch' : 'mouse') : null;
      // Caught ring sparkler on its way to the finger: eases out over 250 ms and
      // follows the finger if it moves; then the finger carries it.
      if (E.fly) {
        if (E.tip) E.fly.to = { x: E.tip.x, y: E.tip.y };
        var k = (now - E.fly.t0) / E.fly.dur;
        if (k < 1) {
          var e = 1 - Math.pow(1 - k, 3);
          tip = { x: E.fly.x + (E.fly.to.x - E.fly.x) * e, y: E.fly.y + (E.fly.to.y - E.fly.y) * e };
          source = 'touch';
        } else {
          if (!E.tip && boost) {
            // The finger lifted before it arrived: it burns down where it landed.
            var span = 350 * longer;
            E.linger = { x: E.fly.to.x, y: E.fly.to.y, until: now + span, span: span };
          }
          E.fly = null;
        }
      }
      if (!tip && E.linger) {
        var left = (E.linger.until - now) / E.linger.span;
        if (left > 0) { tip = E.linger; power = left; source = 'linger'; }
        else E.linger = null;
      }
      if (!tip && opts.orbit && E.ringLeft > 0 && !E.ringOver && now - E.lastTouch > 1400) {
        var o = opts.orbit();
        if (o) {
          E.ang += 0.045;
          E.ringLeft -= 0.045;
          tip = { x: o.x + Math.cos(E.ang) * o.r, y: o.y + Math.sin(E.ang) * o.r };
          scale = 0.55; source = 'orbit';
        }
      }
      E.ringOn = source === 'orbit';
      if (E.ringOn) E.ringTip = tip;
      // Long-exposure streak: the phone ring always left one; on phones a finger
      // now leaves one too, a little wider, fading over about 1.5 s at the default.
      // A new stroke (or a switch between ring and finger) starts a new line, except
      // a catch, whose flight carries on from the ring's line (joinTrail).
      if (source === 'orbit' || (source === 'touch' && boost)) {
        var last = E.trail[E.trail.length - 1];
        E.trail.push({
          x: tip.x, y: tip.y, t: 1, src: source,
          fade: source === 'orbit' ? 0.012 : 0.018 / longer,
          w: source === 'orbit' ? 1 : size,
          brk: E.joinTrail ? false : (!last || last.src !== source || (source === 'touch' && E.newStroke))
        });
        if (source === 'touch') { E.newStroke = false; E.joinTrail = false; }
      }
      E.trail = E.trail.filter(function (p) { return (p.t -= p.fade) > 0; });
      ctx.lineCap = 'round';
      for (var i = 1; i < E.trail.length; i++) {
        var a = E.trail[i - 1], b = E.trail[i];
        if (b.brk) continue;
        ctx.strokeStyle = 'rgba(255,205,120,' + b.t * 0.55 + ')';
        ctx.lineWidth = 2.2 * b.t * b.w;
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      }
      if (tip) {
        var n = Math.round((opts.density * scale + Math.random()) * power);
        for (var k = 0; k < n; k++) E.emit(tip.x, tip.y, (1.5 + Math.random() * 3.5 * scale) * size, (22 + Math.random() * 22) * longer, size, longer);
        glow(tip.x, tip.y, 22 * (scale < 1 ? 0.8 : 1) * size, power);
      }
      E.sparks = E.sparks.filter(function (p) {
        p.px = p.x; p.py = p.y; p.vy += 0.06; p.vx *= 0.985; p.vy *= 0.985; p.x += p.vx; p.y += p.vy; p.life--;
        var t = p.life / p.max;
        if (t <= 0) return false;
        ctx.strokeStyle = t > 0.6 ? 'rgba(255,244,210,' + t + ')' : 'rgba(235,' + ((120 + 90 * t) | 0) + ',40,' + t + ')';
        ctx.lineWidth = (1.4 * t + 0.3) * p.w;
        ctx.beginPath(); ctx.moveTo(p.px - p.vx * 1.5, p.py - p.vy * 1.5); ctx.lineTo(p.x, p.y); ctx.stroke();
        if (p.split && t < 0.55) {
          p.split = false;
          for (var m = 0; m < 3; m++) E.emit(p.x, p.y, (1 + Math.random() * 1.5) * p.w, (12 + Math.random() * 10) * p.l, p.w, p.l);
        }
        return true;
      });
      return !!(tip || E.linger || E.sparks.length || E.trail.length);
    };
    return E;
  }

  function init(root) {
    if (!root || root.dataset.dwReady) return;
    root.dataset.dwReady = '1';
    var cfg = root.dataset;

    // Everything set up outside this section (window and document listeners, the
    // sparkler canvas in <body>) is undone when the theme editor unloads it.
    var offs = [];
    function on(target, type, fn, opt) {
      target.addEventListener(type, fn, opt);
      offs.push(function () { target.removeEventListener(type, fn, opt); });
    }
    root.addEventListener('dw:destroy', function () {
      offs.forEach(function (off) { off(); });
      offs = [];
    });

    /* ----- countdown ----- */
    var target = Date.parse(cfg.saleStart || '');
    var cells = {
      d: root.querySelector('[data-dw-cd="d"]'), h: root.querySelector('[data-dw-cd="h"]'),
      m: root.querySelector('[data-dw-cd="m"]'), s: root.querySelector('[data-dw-cd="s"]')
    };
    function pad(n) { return String(Math.floor(n)).padStart(2, '0'); }
    function tick() {
      if (isNaN(target) || !cells.d) return;
      var d = Math.max(0, target - Date.now()) / 1000;
      cells.d.textContent = pad(d / 86400);
      cells.h.textContent = pad(d % 86400 / 3600);
      cells.m.textContent = pad(d % 3600 / 60);
      cells.s.textContent = pad(d % 60);
    }
    tick();
    var tickTimer = setInterval(tick, 1000);
    offs.push(function () { clearInterval(tickTimer); });

    /* ----- internal parallax: the photo drifts inside its frame as the page scrolls ----- */
    var photo = root.querySelector('[data-dw-photo]');
    var img = photo && photo.querySelector('.dw__img');
    var plx = parseFloat(cfg.parallax) / 100 || 0;
    if (img && plx > 0 && !reduceMotion) {
      // The CSS makes the <img> taller than its frame by plx at each end; sliding it
      // by up to plx of the frame's height either way never shows an edge.
      root.classList.add('dw--parallax');
      var plxRaf = 0;
      var drift = function () {
        plxRaf = 0;
        var r = photo.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.bottom < 0 || r.top > vh) return;
        // The photo travels its whole spare height across the scroll in which it is
        // actually on screen: from the top of the page (it's in view on load) or from
        // when its top enters at the bottom, until its bottom leaves at the top. Mapping
        // over "enters to leaves" instead wasted half the travel on a photo that starts
        // in view, and read as too slow (user, 19 Oct).
        var y = window.scrollY || window.pageYOffset || 0;
        var top = r.top + y;
        var start = Math.max(0, top - vh), end = top + r.height;
        var p = Math.min(1, Math.max(0, (y - start) / Math.max(1, end - start)));
        img.style.transform = 'translate3d(0,' + ((p - 0.5) * 2 * plx * r.height).toFixed(1) + 'px,0)';
      };
      var queueDrift = function () { if (!plxRaf) plxRaf = requestAnimationFrame(drift); };
      on(window, 'scroll', queueDrift, { passive: true });
      on(window, 'resize', queueDrift);
      drift();
    }

    /* ----- sparkler ----- */
    var canvas = root.querySelector('[data-dw-sparks]');
    var engine = null, raf = 0;
    if (canvas && !reduceMotion && canvas.getContext) {
      // Anywhere on the page (Punit, 19 Oct): the canvas moves to <body>, fixed over
      // the window just under the site header (z-index in the CSS), and the whole
      // document drives it. <html>.dw-sparkler turns the cursor into the crosshair.
      document.body.appendChild(canvas);
      document.documentElement.classList.add('dw-sparkler');
      offs.push(function () {
        canvas.remove();
        document.documentElement.classList.remove('dw-sparkler');
      });

      var dial = {
        x: parseFloat(cfg.dialX) / 100 || 0.535,
        y: parseFloat(cfg.dialY) / 100 || 0.468,
        r: parseFloat(cfg.dialR) / 100 || 0.19
      };
      var photoVisible = true;
      var phoneSize = parseFloat(cfg.phoneSize) || 1.5;
      var phoneLife = parseFloat(cfg.phoneLife) || 1.8;
      var ringLoops = parseInt(cfg.ringLoops, 10);
      engine = makeEngine(canvas, {
        density: parseInt(cfg.density, 10) || 6,
        // Times the phone ring goes round before stopping; 0 = no ring. With
        // "until the first touch" on, at most that many: the first touch ends it.
        ringLoops: isNaN(ringLoops) ? 1 : Math.max(0, ringLoops),
        ringUntilTouch: cfg.ringUntilTouch === '1',
        // Phones only (Punit, 20 Oct: "very small and for a short time"): sparks
        // bigger by phoneSize and longer-lived by phoneLife, a streak behind the
        // finger and a short afterglow where it lifts. Section settings "Phone:
        // sparkle size / length"; desktop keeps the design's numbers.
        boost: function () { return desktopQuery.matches ? null : { size: phoneSize, life: phoneLife }; },
        // Phone layout only, while the photo is on screen: the ring sits on the dial.
        // The image is object-fit: cover inside the <img> box, and with parallax that
        // box is taller than the frame and moving, so read where it is now, every frame.
        orbit: function () {
          if (desktopQuery.matches || !img || !photoVisible) return null;
          var ir = img.getBoundingClientRect();
          var bw = ir.width, bh = ir.height;
          var iw = parseFloat(photo.dataset.iw) || 1856, ih = parseFloat(photo.dataset.ih) || 2304;
          var s = Math.max(bw / iw, bh / ih), rw = iw * s, rh = ih * s;
          return {
            x: ir.left + (bw - rw) / 2 + rw * dial.x,
            y: ir.top + (bh - rh) / 2 + rh * dial.y,
            r: rw * dial.r
          };
        }
      });
      engine.resize();
      var loop = function () {
        raf = 0;
        if (engine.frame()) raf = requestAnimationFrame(loop);
      };
      var kick = function () { if (!raf) raf = requestAnimationFrame(loop); };
      root._dwKick = kick;
      offs.push(function () { if (raf) cancelAnimationFrame(raf); raf = 0; });

      if ('ResizeObserver' in window) {
        var resizer = new ResizeObserver(function () { engine.resize(); kick(); });
        resizer.observe(canvas);
        offs.push(function () { resizer.disconnect(); });
      } else {
        on(window, 'resize', function () { engine.resize(); kick(); });
      }
      if ('IntersectionObserver' in window && photo) {
        var seen = new IntersectionObserver(function (entries) {
          photoVisible = entries[0].isIntersecting;
          if (photoVisible) kick();
        });
        seen.observe(photo);
        offs.push(function () { seen.disconnect(); });
      }
      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', kick);
        offs.push(function () { desktopQuery.removeEventListener('change', kick); });
      }

      // Real mice only: phones also send a mousemove after each tap, which would
      // leave the sparkler burning at the last tap. Fingers use the touch events.
      on(document, 'pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        engine.tip = { x: e.clientX, y: e.clientY };
        engine.touch = false;
        kick();
      }, { passive: true });
      // relatedTarget is null only when the pointer leaves the window.
      on(document, 'mouseout', function (e) { if (!e.relatedTarget && !engine.touch) engine.tip = null; });
      var onTouch = function (e) {
        var t = e.touches && e.touches[0];
        if (!t) return;
        if (!engine.touch) {
          engine.newStroke = true;
          engine.catchRing(t.clientX, t.clientY);
        }
        engine.touch = true;
        engine.linger = null;
        engine.tip = { x: t.clientX, y: t.clientY };
        engine.lastTouch = Date.now();
        kick();
      };
      // The ring returns 1.4 s after the last touch, but the loop stops once the
      // touch's sparks die (well before that), so wake it when the wait is over.
      var ringTimer = 0;
      offs.push(function () { clearTimeout(ringTimer); });
      var onTouchEnd = function () {
        engine.release();
        engine.lastTouch = Date.now();
        kick();
        clearTimeout(ringTimer);
        ringTimer = setTimeout(kick, 1450);
      };
      on(document, 'touchstart', onTouch, { passive: true });
      on(document, 'touchmove', onTouch, { passive: true });
      on(document, 'touchend', onTouchEnd, { passive: true });
      on(document, 'touchcancel', onTouchEnd, { passive: true });
      kick();
    }

    /* ----- form ----- */
    var form = root.querySelector('[data-dw-form]');
    var frame = root.querySelector('[data-dw-target]');
    var done = root.querySelector('[data-dw-done]');
    var err = root.querySelector('[data-dw-err]');
    var button = root.querySelector('[data-dw-submit]');
    if (!form || !frame) return;
    var endpoint = (cfg.endpoint || '').trim();

    function showErr(msg) { err.textContent = msg || ''; }
    form.addEventListener('input', function () { showErr(''); });

    function setHidden(name, value) {
      var el = form.elements.namedItem(name);
      if (el) el.value = value || '';
    }

    // Meta (20 Oct 2026): a registration is a CompleteRegistration on Verte's dataset,
    // sent from this page (sendMetaRegistration, top of this file) and, once its token
    // is set, from the Apps Script's Conversions API call, with ONE event_id so Meta
    // counts the pair once. The server call gets the event_id, Meta's _fbp / _fbc
    // cookies and the user agent from the hidden fields filled in on submit.
    function cookie(k) {
      var m = document.cookie.match('(?:^|;)\\s*' + k + '=([^;]*)');
      return m ? decodeURIComponent(m[1]) : '';
    }

    function post() {
      return new Promise(function (resolve, reject) {
        var settled = false, timer;
        function finish(e) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          frame.removeEventListener('load', onLoad);
          if (e) reject(e); else resolve();
        }
        function onLoad() { finish(null); }
        // The response is cross-origin and unreadable, so load is the only success
        // signal; the timeout releases the button if the endpoint never answers.
        timer = setTimeout(function () { finish(new Error('timed out')); }, 25000);
        frame.addEventListener('load', onLoad);
        form.action = endpoint;
        form.submit();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (button.getAttribute('aria-busy') === 'true') return;
      var name = form.elements.namedItem('name').value.trim();
      var phone = form.elements.namedItem('phone').value;
      var city = form.elements.namedItem('city').value.trim();
      if (!name || !city) return showErr(cfg.errFields);
      if (phone.replace(/\D/g, '').length < 10) return showErr(cfg.errPhone);
      if (!endpoint) {
        if (window.console) console.warn('Diwali registration: no endpoint set in the section settings');
        return showErr(cfg.errSend);
      }

      var params = new URLSearchParams(location.search);
      setHidden('page', location.href);
      setHidden('referrer', document.referrer);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        setHidden(k, params.get(k));
      });
      var eventId = 'diwali-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      var fbclid = params.get('fbclid');
      var fbp = cookie('_fbp');
      // No _fbc cookie but the visit came from an ad: build it from fbclid, in Meta's
      // format fb.1.<milliseconds>.<fbclid>.
      var fbc = cookie('_fbc') || (fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : '');
      setHidden('event_id', eventId);
      setHidden('fbp', fbp);
      setHidden('fbc', fbc);
      setHidden('user_agent', navigator.userAgent);

      button.setAttribute('aria-busy', 'true');
      showErr('');
      post().then(function () {
        if (engine) { engine.burstAt(button, desktopQuery.matches ? 260 : 200); if (root._dwKick) root._dwKick(); }
        var first = name.split(/\s+/)[0];
        root.querySelectorAll('[data-dw-first]').forEach(function (el) { el.textContent = first; });
        form.hidden = true;
        done.hidden = false;
        done.focus({ preventScroll: true });
        // Only after the registration went through: this becomes the event Meta ads
        // optimise for, so it must never count a registration that didn't happen.
        sendMetaRegistration({ eventId: eventId, name: name, phone: phone, city: city, fbp: fbp, fbc: fbc });
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('diwali_registration', { event_id: eventId, content_name: 'Diwali 2026 registration' });
          }
        } catch (_) { /* analytics must never block the thank-you state */ }
      }).catch(function () {
        showErr(cfg.errSend);
      }).then(function () {
        button.removeAttribute('aria-busy');
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dw]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Theme editor: sections re-render in place.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-dw]');
    if (root) root.dispatchEvent(new CustomEvent('dw:destroy'));
  });
})();
